import type { Invoice } from "@/api.types.v2";

export function isUnsentInvoice(
  invoice: Pick<Invoice, "status" | "stripeInvoiceId">
): boolean {
  return (
    invoice.status === "DRAFT" ||
    (invoice.status === "OPEN" && !invoice.stripeInvoiceId)
  );
}
